import { Component, OnInit } from '@angular/core';
import { DailyProductionService } from './daily-production.service';
import { CustomizerSettingsService } from '../../../../customizer-settings/customizer-settings.service';

@Component({
    selector: 'app-daily-production',
    imports: [],
    templateUrl: './daily-production.html',
    styleUrl: './daily-production.scss'
})
export class DailyProduction {

    constructor(
        public themeService: CustomizerSettingsService,
        private dailyProductionService: DailyProductionService
    ) { }

    ngAfterViewInit(): void {
        this.dailyProductionService.loadChart();
    }

    ngOnDestroy(): void {
        this.dailyProductionService.destroyChart();
    }

}